import { memo } from "react";

import StickyButton from "@/common/StickyButton";
import i18n from "@/localization/i18next";
import { HandleNext } from "@/types/common";
import { Question } from "@/types/question";

interface CalisthenicsFeedbackLoopsProps {
    handleNext: HandleNext;
    isActive: boolean;
    question: Question;
}
const CalisthenicsFeedbackLoops = ({ handleNext, question }: CalisthenicsFeedbackLoopsProps) => {
    return (
        <div className="grid h-full gap-10 text-white">
            <div className="h-full">
                <div className="-mx-6 md:mx-0">
                    <img src={question.img} alt="" className="w-full" />
                </div>
                <div className="grid gap-4 pt-6 female:text-black">
                    <span className="text-zing-24-32 font-semibold">{question.title}</span>
                    <div className="grid gap-2">
                        <span className="text-zing-16-22">{question.description}</span>
                    </div>
                </div>
            </div>
            <StickyButton
                onClick={() => handleNext()}
                className="items-end transition-opacity"
                isDisabled={false}
            >
                {i18n.t("got_it")}
            </StickyButton>
        </div>
    );
};

export default memo(CalisthenicsFeedbackLoops);
